import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';

function DashedLine({
  className
}) {
  return jsx("svg", {
    height: "2",
    width: "100%",
    children: jsx("line", {
      x1: "0",
      y1: "1",
      x2: "100%",
      y2: "1",
      className: clsx('stroke-gray', className),
      strokeWidth: "1",
      strokeDasharray: "8,8"
    })
  });
}

export { DashedLine };
